export const GET_ENTITIES = 'entities/GET_ENTITIES'
export const GET_ENTITY = 'entities/GET_ENTITY'
export const ADD_ENTITIES = 'entities/ADD_ENTITIES'
export const EDIT_ENTITIES = 'entities/EDIT_ENTITIES'
export const DELETE_ENTITIES = 'entities/DELETE_ENTITIES'
export const ACTIVE_ENTITY = 'entities/ACTIVE_ENTITY'
export const INACTIVE_ENTITY = 'entities/INACTIVE_ENTITY'
export const START_LOADING_ENTITIES = 'entities/START_LOADING_ENTITIES'
export const STOP_LOADING_ENTITIES = 'entities/STOP_LOADING_ENTITIES'   
export const GET_ENTITY_HISTORY = 'entities/GET_HISTORY'
export const GET_ENTITY_SNAPSHOT = 'entities/GET_ENTITY_SNAPSHOT'
